<template>
  <van-popup
    class="practicalTipsBox pcPopup"
    v-model="tipsShow"
    position="bottom"
    overlay-class="tipsOverlay"
    @close="changeClose"
  >
    <div class="practicalTips">
      <div class="tip-head">
        <div class="title-left">
          <img class="icon-logo" src="@/assets/logo.png" alt="" />
          <div class="icon-title">迅流云实用技巧</div>
        </div>
        <van-checkbox
          class="tip-checked"
          icon-size="16px"
          v-model="tipChecked"
          checked-color="#886df3"
          >不再提示</van-checkbox
        >
      </div>
      <div class="tip-content">
        <div class="tip-item">
          <div class="tip-index">1.</div>
          <div class="tip-text">
            <span>点击</span
            ><img class="share" src="@/assets/icons/share.png" alt="" />
            <span>按钮，选择“添加到主屏幕”，一键进入迅流云</span>
          </div>
        </div>
        <div class="tip-item">
          <div class="tip-index">2.</div>
          <div class="tip-text">
            点击地址栏左侧<img
              class="scale"
              src="@/assets/icons/scale.png"
              alt=""
            />按钮，选择“隐藏工具栏”，即可全屏展示
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
        
        <script>
import { mapMutations } from "vuex";
export default {
  name: "Tips",
  components: {},
  data() {
    return {
      tipsShow: false,
      tipChecked: false,
    };
  },
  props: {
    dialogShow: {
      default: "",
      type: Boolean,
    },
  },
  mounted() {
    // this.show=this.dialogShow
  },
  watch: {
    dialogShow(newV, oldV) {
      if (newV) {
        this.tipsShow = newV;
      }
    },
  },

  methods: {
    ...mapMutations("perpetual", ["SET_TIPSSHOW"]),
    confirms() {},
    changeClose() {
      if (this.tipChecked) {
        this.SET_TIPSSHOW(false);
      }
    },
  },
};
</script>
      <style lang="less" scoped>
.practicalTipsBox {
  width: 100%;
  background: transparent;
  padding: 0 26px;
  margin-bottom: 18px;
  overflow: inherit;
  color: #fff;
  .practicalTips {
    width: 100%;
    background: #434547;
    border-radius: 14px;
    padding: 20px 16px;
    position: relative;
    .tip-head {
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .title-left {
        display: flex;
        align-items: center;
        .icon-logo {
          width: 22px;
          height: 22px;
          margin-right: 4px;
        }
      }
      /deep/.tip-checked {
        .van-checkbox__label {
          color: #fff !important;
        }
      }
    }
    .tip-content {
      font-size: 16px;
      text-align: left;
      line-height: 20px;
      .tip-item {
        display: flex;
        margin-top: 16px;
        .tip-index {
          line-height: 24px;
          width: 28px;
        }
        .tip-text {
          line-height: 24px;
        }
        .share {
          width: 20px;
          vertical-align: middle;
          display: inline-block;
          margin-top: -5px;
        }
        .scale {
          width: 34px;
          height: 20px;
          margin: 0 1px;
          vertical-align: middle;
          display: inline-block;
          margin-top: -5px;
        }
      }
    }
  }
  .practicalTips::after {
    content: "";
    position: absolute;
    bottom: -14px;
    left: 50%;
    transform: translateX(-50%);
    border-left-width: 14px;
    border-right-width: 14px;
    border-top-width: 15px;
    border-style: solid;
    border-color: transparent;
    border-top-color: #434547;
  }
}
/deep/.tipsOverlay {
  background-color: transparent !important;
}
</style>